module.exports = __webpack_public_path__ + "img/logo.aaf63a86.png";